import { factory, getResponseCamelization } from '@repo-level/core-front';

export interface ICentrifugoChannelCommit {
  offset: number;
  epoch: string;
}

export interface ICentrifugoSubscription {
  /** Centrifugo WebSocket server URL, without the /connection/websocket suffix */
  url: string;
  /** JWT verified by Centrifugo itself, no auth callback on connect */
  token: string;
  /** Brand identifier, used as the channel name prefix */
  clientName: string;
  /** Centrifugo user identifier: {casinoName}_{playerID} */
  user: string;
  /** Last known position per historical (wsh:) channel, keyed by full channel name */
  channelCommits?: Record<string, ICentrifugoChannelCommit>;
}

// channelCommits is blacklisted from camelization: its keys are channel names, not field names
export const centrifugoSubscription = factory(
  (r) => () =>
    r<ICentrifugoSubscription>(
      'get',
      'notification_center/centrifugo/subscription',
      undefined,
      { transformResponse: [getResponseCamelization([['channelCommits']])] }
    )
);
